import { Outlet } from 'react-router-dom';
import { Col, Container, Nav, Row } from 'react-bootstrap';
import { FileCodeFill, Github, Linkedin, Twitter } from 'react-bootstrap-icons';

import './Layout.css';

function Layout() {

    return (
        <>
            <Container>
                <div className='text-center mt-3'>
                    <a href='/' className='text-black text-decoration-none layout-title'><h2>91d906h4's Blog</h2></a>
                </div>
                <hr style={{ margin: '1px'}} />
                <Nav className='d-flex justify-content-around mb-3'>
                    <Nav.Link href='/' className='text-secondary'>Home</Nav.Link>
                    <Nav.Link href='/article?page=1' className='text-secondary'>Article</Nav.Link>
                    <Nav.Link href='/about' className='text-secondary'>About</Nav.Link>
                </Nav>
            </Container>

            <Outlet />
            <br />

            <footer className='w-100 py-4 flex-shrink-0 mt-auto bg-light'>
                <Container className='p-4 bg-light'>
                    <Row className='gy-4 gx-5'>
                        <Col md={6} lg={4}>
                            <h1 className='layout-footer-title'>91d906h4</h1>
                            <p className="small text-muted">I'm a software developer, also interested in deep learning (PyTorch, TensorFlow). Currently learning C/C++.</p>
                            <p className="small text-muted mb-0">&copy; 2022 91d906h4. All rights reserved.</p>
                        </Col>
                        <Col xs={6} lg={2}>
                            <h5 className="mb-3">Links</h5>
                            <ul className="list-unstyled text-muted">
                                <li><a href='https://github.com/91d906h4' target='_blank' rel='noreferrer' className='text-decoration-none text-dark'><Github></Github> GitHub</a></li>
                                <li><a href='https://www.linkedin.com/in/幸彦-鈴木-65a24323a/' target='_blank' rel='noreferrer' className='text-decoration-none text-dark'><Linkedin></Linkedin> LinkedIn</a></li>
                                <li><a href='https://leetcode.com/91d906h4' target='_blank' rel='noreferrer' className='text-decoration-none text-dark'><FileCodeFill></FileCodeFill> LeetCode</a></li>
                                <li><a href='https://twitter.com/91d906h4' target='_blank' rel='noreferrer' className='text-decoration-none text-dark'><Twitter></Twitter> Twitter</a></li>
                            </ul>
                        </Col>
                        <Col xs={6} lg={2}>
                            <h5 className="mb-3">Quick links</h5>
                            <ul className="list-unstyled text-muted">
                                <li><a href='/' className='text-decoration-none text-dark'>Home</a></li>
                                <li><a href='/article?page=1' className='text-decoration-none text-dark'>Article</a></li>
                                <li><a href='/about' className='text-decoration-none text-dark'>About</a></li>
                            </ul>
                        </Col>
                        <Col md={6} lg={4}>
                            <h5 className="mb-3">MeFo Ku KaKaLaTo</h5>
                            <p className="small text-muted">《 LaHiLaMiTa KaHeMo Ka KeBeLaKa Ki DeVaYaKa ToFo, ViDuMo ToFo NeLuMiGoZeZo LaHiLaMiTa. 》 -  DeLaMuNo, 1985</p>
                        </Col>
                    </Row>
                </Container>
            </footer>
            {/*
                View counter
                <img src="http://www.ul5.com/ccaf84677c15f9102754596acebe376d0.jpg" />
            */}
        </>
    );
}

export default Layout;